var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Ads")]),
      !_vm.isLive
        ? _c("dfp", {
            attrs: {
              ads: _vm.ads,
              platforms: _vm.platforms,
              formSubmitted: _vm.formSubmitted,
              validations: _vm.validations
            },
            on: { error: _vm.emitError }
          })
        : _vm._e(),
      !_vm.ads.dfpEnabled
        ? _c("vast", {
            attrs: {
              ads: _vm.ads,
              platforms: _vm.platforms,
              formSubmitted: _vm.formSubmitted,
              validations: _vm.validations
            },
            on: { error: _vm.emitError }
          })
        : _vm._e(),
      !_vm.ads.dfpEnabled
        ? _c("image-banner", {
            attrs: {
              ads: _vm.ads,
              platforms: _vm.platforms,
              formSubmitted: _vm.formSubmitted,
              validations: _vm.validations
            },
            on: { error: _vm.emitError }
          })
        : _c("ooyala", {
            attrs: {
              ooyalaParams: _vm.ads.ooyala,
              formSubmitted: _vm.formSubmitted,
              validations: _vm.validations.ooyala
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ad28a3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad28a3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/AdsForm.vue
// module id = 784
// module chunks = 0